module.exports = __webpack_public_path__ + "img/oops.5474e0d8.svg";